import { render } from "./TicketMessages.vue?vue&type=template&id=1a038044&ts=true"
import script from "./TicketMessages.vue?vue&type=script&lang=ts"
export * from "./TicketMessages.vue?vue&type=script&lang=ts"

import "./TicketMessages.vue?vue&type=style&index=0&id=1a038044&lang=scss"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInfiniteScroll,QSpinner,QBtn,QInput,QFile,QField});
